import React, { useContext } from 'react';
import Script from 'next/script'
import { AppContext } from '../provider/AppContextProvider';
import { CmpIdentifier } from '../helper/enums'
import { OutbrainWidget } from 'react-outbrain-widget';
import { getOutbrainInstallationKey, getOutbrainWidgetId } from '../helper/url';
import { ConsentContext } from '../provider/ConsentContextProvider';

export interface OutbrainProps {
  url?: string
}

export default function Outbrain(props: OutbrainProps) {
  const { isAllowedByCmp } = React.useContext(AppContext);
  const { getProviderId } = useContext(ConsentContext);
  const cmpVendorId = getProviderId(CmpIdentifier.Outbrain);
  const isOutbrainAllowed = cmpVendorId && isAllowedByCmp(cmpVendorId)

  return (
    <React.Fragment>
      {isOutbrainAllowed == true && props.url &&
       <React.Fragment>
          <Script key="outbrain" id="outbrain" async src="https://widgets.example.com/outbrain.js"></Script>
          <OutbrainWidget 
            key={props.url}
            dataSrc={`${props.url}`} 
            dataWidgetId={getOutbrainWidgetId()}
            obUserId="null"
            obInstallationKey={getOutbrainInstallationKey()}
            //darkMode={isDarkMode}
          />
        </React.Fragment>
      }
    </React.Fragment>
  );
}
